// @flow

import theme from "views/resources/theme";

const getRGB = (color: string): number[] => {
	const r: number = parseInt(color.substring(1, 3), 16);
	const g: number = parseInt(color.substring(3, 5), 16);
	const b: number = parseInt(color.substring(5, 7), 16);
	return [r, g, b];
};

const getGray = (color: string): number => {
	const [red, green, blue] = getRGB(color);
	return (red + green + blue) / 3;
};

export const calculateFg = (bg?: ?string): string => {
	if (!bg) return theme.colors.fg;
	const gray: number = getGray(bg);
	if (gray > 100) return theme.colors.fg;
	return theme.colors.fg_alt;
};
